<script>
  export let text = null;
  export let type = "button";
  export let disabled = false;
  export let compact = false;
  export let danger = false;
  export let primary = false;
</script>

{#if text}
  <button
    class:compact
    class:danger
    class:primary
    {type}
    class={$$props.style}
    {disabled}
    on:click
  >
    {text}
  </button>
{:else}
  <button
    class:compact
    class:danger
    class:primary
    {type}
    class={$$props.style}
    {disabled}
    on:click
  >
    <slot />
  </button>
{/if}

<style>
  button {
    margin: 0;
    display: inline-block;
    padding: 14px 48px;
    background-color: inherit;
    border: 1px solid var(--blue-color);
    font-size: 12px;
    line-height: 20px;
    text-transform: uppercase;
    font-weight: 500;
    letter-spacing: 0.08rem;
    border-radius: 0;
    color: var(--blue-color);
    cursor: pointer;
    user-select: none;
    transition: all 0.2s ease-in-out;
    white-space: nowrap;
    outline: none;
  }

  button.compact {
    padding: 9px 24px;
  }

  .inverted {
    color: #fff;
    border: 1px solid #fff;
  }

  .inverted:hover {
    background-color: #fff;
    color: black;
    border: 1px solid black;
  }

  .inline {
    padding: 0 8px;
    border: 0;
    display: inline-flex;
    align-items: center;
    justify-content: center;
    background-color: #f9f9f9;
    line-height: inherit;
  }

  .inline:hover {
    background-color: #eee;
    color: black;
    fill: black;
    stroke: black;
  }

  .inline:focus {
    background-color: #ddd;
    color: black;
    fill: black;
    stroke: black;
  }

  .long {
    min-width: 300px;
  }

  button:hover {
    background-color: var(--light-hover);
    border-color: var(--light-hover);
  }

  button:focus {
    background-color: var(--light-dark);
    border-color: var(--light-dark);
  }

  button:disabled {
    cursor: auto;
    color: #ddd;
    background-color: inherit;
    border: 1px solid #ddd;
  }

  button:disabled:hover {
    color: #ddd;
    background-color: inherit;
    border: 1px solid #ddd;
  }

  button:disabled.filled,
  button:disabled.primary {
    background-color: #999;
    border: 1px solid #999;
  }

  button:disabled.filled:hover,
  button:disabled.primary:hover {
    color: #fff;
    border: 1px solid #999;
    background-color: #999;
  }

  button.filled {
    color: #fff;
    background-color: var(--night);
    border-color: var(--night);
  }

  button.filled:hover {
    background-color: var(--night-light);
    border-color: var(--night-light);
  }

  button.filled:hover {
    background-color: var(--night-light);
    border-color: var(--night-light);
  }

  button.filled:focus {
    background-color: var(--night-dark);
    border-color: var(--night-dark);
  }

  button.primary {
    color: white;
    background-color: var(--accent);
    border-color: var(--accent);
  }

  button.primary:hover {
    background-color: var(--accent-light);
    border-color: var(--accent-light);
  }

  button.primary:focus {
    background-color: var(--accent-dark);
    border-color: var(--accent-dark);
  }

  button.danger {
    color: var(--danger);
    border-color: var(--danger);
  }

  button.danger:hover {
    background-color: var(--light-hover);
    border-color: var(--light-hover);
  }
</style>
